module.exports = __webpack_public_path__ + "img/phone.82663795.svg";